import './LoadingIcon.scss';

import type { ModifiersType, ModifiersTypeMap } from '@utils';
import { createClsNameMap, mergeModifiers } from '@utils';

export const clsNameMap = createClsNameMap({
  elements: {
    default: createClsNameMap({}),
  },
  modifiers: ['filter'],
})('loading-icon');

export type LoadingIconProps = React.HTMLAttributes<HTMLSpanElement> & {
  modifiers?: ModifiersTypeMap<typeof clsNameMap> | ModifiersType<typeof clsNameMap>;
};

const LoadingIcon = ({ modifiers, children, ...otherProps }: LoadingIconProps) => {
  return (
    <div {...otherProps} className={mergeModifiers(clsNameMap, [modifiers])}>
      {!children ? <span className={clsNameMap.elm('default')}></span> : children}
    </div>
  );
};

export default LoadingIcon;
